import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import {
  TextField,
  TextFieldProps,
  createSvgIcon,
  useTheme,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ja from "dayjs/locale/ja";
import { Dayjs } from "dayjs";

type Props = {
  label: string;
  value: Dayjs;
  setValue: (s: any) => void;
  shouldDisableDate: (date: any) => boolean;
};

const FilterDatePicker = (props: Props) => {
  const theme = useTheme();

  const customColor = {
    color: theme.palette.base.contrast,
  };

  const calenderIcon = createSvgIcon(
    <path
      fill={customColor.color}
      fillRule="evenodd"
      d="M3,9 L21,9 L21,6 L3,6 L3,9 Z M3,18 L21,18 L21,10.5 L3,10.5 L3,18 Z M18,4.5 L18,3 L16.5,3 L16.5,4.5 L7.5,4.5 L7.5,3 L6,3 L6,4.5 L1.5,4.5 L1.5,6 L1.5,19.5 L3,19.5 L21,19.5 L22.5,19.5 L22.5,6 L22.5,4.5 L18,4.5 Z"
    />,
    "Calender"
  );
  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ja}>
        <DesktopDatePicker
          label={props.label}
          value={props.value}
          inputFormat="YYYY/MM/DD"
          mask="____/__/__"
          onChange={(value: any) => {
            props.setValue(value);
          }}
          shouldDisableDate={props.shouldDisableDate}
          renderInput={(params: JSX.IntrinsicAttributes & TextFieldProps) => (
            <TextField size="small" {...params} />
          )}
          components={{ OpenPickerIcon: calenderIcon }}
          InputProps={{ sx: { borderRadius: "0px" } }}
        />
      </LocalizationProvider>
    </>
  );
};

export default FilterDatePicker;
